<template>
	<div class="login-container">
		<h1>Sektion</h1>
		<h1 class="font-italic">I sandhedens Tjeneste</h1>

		<div class="button-container mt-5">
			<router-link to="/manager/control-panel" class="btn btn-primary">Faciliator</router-link>
			<router-link to="/manager/results" class="btn btn-primary ml-3">Resultater</router-link>
		</div>
	</div>
</template>

<script>
	import * as MutationTypes from '@/store/mutation-types'
	import {mapGetters} from 'vuex';

	export default {
		name: 'manager-section-view',
		components: {
		},
		beforeMount() {
			let managerCode = this.$apiClient.getHttp().defaults.headers.common['X-Manager-Code'];

			if (!managerCode) {
				this.$router.push('/manager/');

				return;
			}
		},
	}
</script>

<style lang="scss" scoped>
	.login-container {
		@include alignCenter();

		background: #f0f0f0;
		padding: 50px;
	}

	.logo-container {
		text-align: center;

		margin: 0 auto;

		img {
			max-width: 200px;
		}
	}

	h1 {
		text-align: center;
		line-height: 100%;

		margin-bottom: 0;
	}

	p {
		text-align: center;
		font-size: 10pt;
	}

	.button-container {
		text-align: center;
	}
</style>
